let pageResizeFn;
function bindPageResize(page) {
    pageResizeFn && window.removeEventListener('resize', pageResizeFn);
    pageResizeFn = function () {
        page.onResize && page.onResize({
            size: {
                windowHeight: window.innerHeight,
                windowWidth: window.innerWidth
            }
        });
    };
    window.addEventListener('resize', pageResizeFn, false);
}

export { bindPageResize };
